import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Container from "@mui/material/Container";

import { useOnboarding } from "../../../contexts/onboarding";
import { ReactComponent as ChevronDown } from "../../../assets/Icons/chevron-down.svg";
import { useCommon } from "../../../contexts/common";
import AgesSelection from "../../AgesSelection";
import { group_practice, treatment_program } from "../../../constants/common";
import "./style.css";
import { clientTypeSchema } from "../../../validations/registerValidation";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
// import CustomButton from "../../CustomButton";
import { LoadingButton } from "@mui/lab";
import sortAgeRanges from "../../../utils/sortAges";
import { useAlert } from "../../../contexts/Alert";
import { useSearchParams } from "react-router-dom";
import { trackClickEvent } from "../../../mixpanel";

const ClientServed = () => {
  const { updateOnboardingState, onboardingState, signUp, uuid, next } =
    useOnboarding();
  const { sendAlert } = useAlert();
  const { clientTypesList, fetchClientTypesList } = useCommon();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [searchParams] = useSearchParams();
  const promoCity = searchParams.get("city");

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    trigger,
  } = useForm({
    resolver: zodResolver(clientTypeSchema),
    defaultValues: {
      client_types: onboardingState.client_types || [],
    },
    mode: "onChange",
  });

  const handleSelect = (ev) => {
    setValue("client_types", ev.target.value);
    updateOnboardingState({ [ev.target.name]: ev.target.value });
    trigger("client_types");
  };

  const onSubmit = async () => {
    if (
      !onboardingState.age_served ||
      onboardingState.age_served?.length === 0
    ) {
      setError(true);
      return;
    }

    if (
      [treatment_program, group_practice].includes(onboardingState.account_type)
    ) {
      trackClickEvent("TP-Step 5 - Client Served", {
        page: "Register",
        component: "Client Served selection",
        button: "Continue",
        accountType: onboardingState?.account_type
      });
      next();
      return;
    }

    // if (isValid && !cardIsInvalid.cardNumber && !cardIsInvalid.cardExpiry && !cardIsInvalid.cardCvc) {
    setLoading(true);
    try {
      // const payloadData = { ...state };
      // const name = payloadData.name;
      // const plan_id = onboardingState.payment_method_id;
      // delete payloadData.name;
      // delete payloadData.payment_method_id;
      const age_served = onboardingState.age_served
        ? sortAgeRanges(onboardingState.age_served).join(",")
        : onboardingState.age_served?.join(",");
      const payload = {
        ...onboardingState,
        office_hours_day: onboardingState.office_hours_day?.join(","),
        office_hours_time: onboardingState.office_hours_time?.join(","),
        age_served: age_served,
        uuid,
        promo_city: promoCity,
        // billing_address: {
        //   ...payloadData,
        // },
      };

      Object.keys(payload).forEach((key) => {
        if (!payload[key]) {
          delete payload[key];
        }
      });

      trackClickEvent("U-Step 8 - Client Served", {
        page: "Register",
        component: "Client Served selection",
        button: "Sign up",
      });

      const response = await signUp(payload);

      // if (response?.data?.data?.client_secret) {
      //   const result = await stripe.confirmCardSetup(
      //     response?.data?.data?.client_secret,
      //     {
      //       payment_method: {
      //         card: elements.getElement("cardNumber"),
      //         billing_details: { name },
      //       },
      //     }
      //   );

      //   trackClickEvent(
      //     'Subscription modal',
      //     { page: 'Register', button: 'Sign up' }
      //   );

      //   if (result.setupIntent) {
      //     await confirmSubscription(
      //       {
      //         payment_token: result.setupIntent.payment_method,
      //         plan_id,
      //         uuid,
      //         promo_city: promoCity,
      //         billing_address: {
      //           ...payloadData,
      //         },
      //       },
      //       response?.data?.data
      //     );
      //   } else {
      //     sendAlert(
      //       "Something went wrong"
      //     );
      //   }
      // }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      sendAlert(
        "Something went wrong, please check your details and make sure it's correct",
        "error"
      );
      // await deleteRegistration(uuid);
    }
    // } else {
    //   setIsInvalid(true);
    // }
  };

  useEffect(() => {
    fetchClientTypesList();
  }, []);

  return (
    <Container maxWidth="md">
      <div className="clients_served">
        {![treatment_program, group_practice].includes(
          onboardingState.account_type
        ) && (
          <>
            <Box>
              <Typography variant="h4">Client Focus</Typography>
              <Typography variant="body1" sx={{ pt: 1 }}>
                What types of clients do you work with?
              </Typography>
            </Box>
            <FormControl error={!!errors.client_types}>
              <InputLabel id="demo-multiple-checkbox-label">
                Client Types*
              </InputLabel>
              <Controller
                name="client_types"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    input={<OutlinedInput label="Type of Clients*" />}
                    renderValue={(selected) =>
                      selected
                        .map(
                          (id) =>
                            clientTypesList.find((item) => id === item.id)?.name
                        )
                        .join(", ")
                    }
                    value={field.value}
                    IconComponent={() => (
                      <Box
                        sx={{
                          minWidth: 24,
                          width: 24,
                          height: 24,
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: 2,
                        }}
                      >
                        <ChevronDown width={12} height={6} />
                      </Box>
                    )}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 224,
                          width: 250,
                        },
                      },
                    }}
                    onChange={handleSelect}
                  >
                    {clientTypesList.map((item) => (
                      <MenuItem key={item.id} value={item.id} sx={{ gap: 1 }}>
                        <Checkbox
                          sx={{ p: 0 }}
                          checked={
                            !!(onboardingState.client_types || []).find(
                              (id) => id === item.id
                            )
                          }
                        />
                        <ListItemText primary={item.name} />
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              {errors.client_types && (
                <Typography color="error" variant="body2">
                  {errors.client_types.message || "Please select client types"}
                </Typography>
              )}
            </FormControl>
          </>
        )}
        <AgesSelection
          data={onboardingState}
          setData={updateOnboardingState}
          clientTypesList={clientTypesList}
          isInvalid={error}
          title={" "}
          subtitle={
            ![treatment_program, group_practice].includes(
              onboardingState.account_type
            )
              ? "What ages do you see?"
              : ""
          }
        />
      </div>

      <div className="buttons_education">
        {/* // page='Register'
          // eventName='Step - Client Served' */}
        <LoadingButton
          name="Continue"
          variant="contained"
          fullWidth
          sx={{
            maxWidth: 212,
          }}
          onClick={async (e) => {
            if (
              ![treatment_program, group_practice].includes(
                onboardingState.account_type
              )
            ) {
              await trigger("client_types");
              if (isValid) {
                handleSubmit(onSubmit)(e);
              }
            } else {
              onSubmit(e);
            }
          }}
          loading={loading}
        >
          Continue
        </LoadingButton>
      </div>
    </Container>
  );
};

export default ClientServed;
